import React from 'react';
import { Link } from 'react-router-dom';

export default function VerificationSuccessPage() {
    return (
        <div className="form-container">
            <h2>Email Verified Successfully!</h2>
            <p>Your email has been verified. You can now log in.</p>
            <Link to="/login" className="btn">Go to Login</Link>
        </div>
    );
}
